/* eslint-disable react/prop-types */
/* eslint-disable max-len */

import React from 'react';
import styled from 'styled-components';

import Typography from '@ntuctech/devex-tangram/Typography';

import PageHeader from '../PageHeader';
import PageContent from '../PageContent';
import MainGirlConfused from '../Illust/MainGirlConfused';

import { BREAKPOINT_BELOW_XS, BREAKPOINT_BELOW_M } from '../../../constants';

const LinkIdLogo = styled.div`
  background-image: url('https://media.nedigital.sg/linkpass/files/3364f6ff-72e1-4c64-9e2c-8b10746c04cd/Link_Logo_RGB.svg');
  width: 7.5rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  top: 4.375rem;
  left: 3rem;
`;

const ErrorPageContentSC = styled(PageContent)`
  width: 100%;
  padding: 3rem;
  box-shadow: none;
  text-align: center;

  .ErrorPage__Logo {
    width: 7rem;
    top: 2rem;
    left: 2.5rem;
  }

  .ErrorPage__Message {
    max-width: 32rem;
    margin: auto;
  }

  .ErrorIllustration {
    margin-top: 5rem;
    margin-bottom: 3rem;
    max-width: 27.75rem;
    width: 27.75rem;
    will-change: width;
    transition: width 0.3s linear;
  }

  @media (${BREAKPOINT_BELOW_M}) {
    .ErrorPage__Logo {
      width: 5.75rem;
      top: 1.5rem;
      left: 1.5rem;
    }

    .ErrorIllustration {
      max-width: 15rem;
      width: 15rem;
      margin-bottom: 2rem;
    }
  }

  @media (${BREAKPOINT_BELOW_XS}) {
    .ErrorIllustration {
      width: calc(100% - 2rem);
    }
  }
`;

const ErrorPageContent = ({ title, body, ...rest }) => {
  const [errorString, setErrorString] = React.useState('');

  React.useEffect(() => {
    // to decode HTML entities in error string
    const txt = document.createElement('textarea');
    txt.innerHTML = body;
    setErrorString(txt.value);
  }, [body]);

  return (
    <ErrorPageContentSC {...rest}>
      <LinkIdLogo className="ErrorPage__Logo" data-testid="ErrorPageLogo" />
      <MainGirlConfused />
      <PageHeader header={title} />
      <Typography data-testid="pageError" className="ErrorPage__Message" variant="body3">
        {errorString}
      </Typography>
    </ErrorPageContentSC>
  );
};

export default ErrorPageContent;
